<script>
  import { fly, fade } from 'svelte/transition';
  import { asnavigate } from '../Utils/asnavigation.js';
  import { useNavigate, useFocus } from 'svelte-navigator';
  export let navigate;
  navigate = useNavigate();
</script>

<span
  class="as-btn-faq"
  on:click="{() => {
    navigate('../../faq');
  }}"
>
  FAQ
</span>

<style>
  .wrapper-faq {
    /* position: absolute;
    bottom: 100px;
    right: 100px; */
  }
  .as-btn-faq {
    cursor: pointer;
    color: #fff;
    /* transition: all 300ms; */
  }
  .as-btn-faq:hover {
    border-bottom: 1px solid #fff;
  }
</style>
